import { render, staticRenderFns } from "./digitalcuaderno.vue?vue&type=template&id=c0a4e336"
import script from "./digitalcuaderno.vue?vue&type=script&lang=js"
export * from "./digitalcuaderno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports